import React from 'react';
// styles
import styled from 'styled-components';

const LoadTypeUnloadIcon = ({ className, ...props }) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Load Type Unload"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7061 6.62849C10.7061 6.11073 11.1259 5.69099 11.6436 5.69099C12.1614 5.69099 12.5811 6.11073 12.5811 6.62849L12.5811 16.3471L14.8996 14.0286C15.2657 13.6625 15.8593 13.6625 16.2254 14.0286C16.5915 14.3948 16.5915 14.9884 16.2254 15.3545L12.3658 19.2141L12.3583 19.2215L12.3511 19.2288C11.9931 19.5868 11.4127 19.5868 11.0547 19.2288L11.04 19.2141L7.04776 15.2219C6.68978 14.8639 6.68978 14.2835 7.04776 13.9255C7.40574 13.5675 7.98614 13.5675 8.34412 13.9255L10.7061 16.2875L10.7061 6.62849ZM18.5833 4.83341C19.0896 4.83341 19.5 4.423 19.5 3.91674C19.5 3.41048 19.0896 3.00008 18.5833 3.00008L5.41667 3.00008C4.91041 3.00008 4.5 3.41048 4.5 3.91674C4.5 4.423 4.91041 4.83341 5.41667 4.83341L18.5833 4.83341Z"
      fill="#54708C"
    />
  </svg>
);

export default styled(LoadTypeUnloadIcon)``;
